<template>
  <el-dialog
      :visible="isVisible"
      @close="hide"
      :title="title"
      :destroy-on-close="true"
  >
    <div class="wrapper" v-loading="!isInitialized" element-loading-spinner="el-icon-loading">
      <note-list-table :items="items"></note-list-table>
    </div>
  </el-dialog>
</template>

<script>
import BaseDialogFormWrapper from "../dialog-form-wrapper";
import eventBus from "../../event-bus";
import NoteListTable from "../send-list-note/table";

export default {
  extends: BaseDialogFormWrapper,

  components: {
    NoteListTable,
  },

  computed: {
    /**
     * @return {string}
     */
    title() {
      if (!this.isInitialized) {
        return 'Loading ...';
      }

      return 'Note List';
    },

    /**
     * @return {Array}
     */
    items() {
      return _.get(this.formData, 'data', []);
    },
  },

  created() {
    eventBus.$on('show-send-list-note-index-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-send-list-note-index-dialog', this.show);
  },
}
</script>

<style scoped>

</style>
